/**
 * Конфиг визуала колб и жидкости.
 * Колесо и колбы — яркие: светлое стекло, яркие границы и блики, сочные жидкости.
 */

import type { RingColor } from './drumConfig';

/** Цвет «стекла» колбы: светлый серо-голубой, хорошо читаемый */
export const VIAL_GLASS_FILL = 0x3a4255;
export const VIAL_GLASS_ALPHA = 0.65;

/** Граница стекла: яркая светлая грань */
export const VIAL_GLASS_BORDER = 0xb8c8e0;
export const VIAL_GLASS_BORDER_ALPHA = 1;
export const VIAL_GLASS_BORDER_WIDTH = 3;

/** Внутренняя грань (внутренний край трубы) */
export const VIAL_GLASS_INNER_EDGE = 0x4a5266;
export const VIAL_GLASS_INNER_EDGE_ALPHA = 0.85;

/** Блик по внешнему краю секции — яркий, заметный */
export const VIAL_GLASS_HIGHLIGHT_WIDTH = 10;
export const VIAL_GLASS_HIGHLIGHT_COLOR = 0xe8f0ff;
export const VIAL_GLASS_HIGHLIGHT_ALPHA = 0.5;
/** Ширина блика на границах секций */
export const VIAL_GLASS_SEPARATOR_HIGHLIGHT_WIDTH = 5;

/** Перегородки между секциями — хорошо видны */
export const VIAL_SEPARATOR_COLOR = 0x7a8aa0;
export const VIAL_SEPARATOR_ALPHA = 0.7;
export const VIAL_SEPARATOR_WIDTH = 1.5;

/** Цвета сока: арбуз / драгонфрукт / киви */
export const VIAL_JUICE_COLORS: Record<RingColor, number> = {
  red: 0xff0044,   // яркий красный (арбуз)
  green: 0xe91e8c, // яркий розово-малиновый (драгонфрукт)
  blue: 0xccff44,  // яркий лаймовый (киви)
};

/** Прозрачность жидкости: плотный, сочный сок (почти непрозрачный) */
export const VIAL_JUICE_ALPHA = 0.97;

/** Поверхность как в бутылке: вся линия уровня колеблется вверх-вниз (амплитуда в пикселях) */
export const VIAL_WAVE_AMPLITUDE = 4;
export const VIAL_WAVE_SPEED = 0.003;

/** Сила притяжения: наклон поверхности к «дну» секции (к центру), пикселей */
export const VIAL_GRAVITY_TILT = 5;

/** Длительность анимации заполнения секции соком (мс) */
export const VIAL_FILL_DURATION_MS = 400;
/** Длительность анимации опорожнения (череп) (мс) */
export const VIAL_DRAIN_DURATION_MS = 350;
